import { Box, Typography } from "@mui/material";

export function PlanBenefits({ features }: { features: string[] }) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 0.75,
                mt: 0.7,
            }}
        >
            {features.map((feature, index) => (
                <Box
                    key={feature}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 13,
                            color: "var(--fx-surface-textsecondary, #64748B)",
                            fontWeight: 500,
                            lineHeight: 1.2,
                        }}
                    >
                        {feature}
                    </Typography>

                    {index < features.length - 1 ? (
                        <Box
                            sx={{
                                width: 4,
                                height: 4,
                                borderRadius: "50%",
                                bgcolor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.16)",
                            }}
                        />
                    ) : null}
                </Box>
            ))}
        </Box>
    );
}